<template>
  <el-row>
    <el-col :span="spanTitle">
      <div class="input-title">出品価格</div>
    </el-col>
    <el-col :span="spanSetting">
      <div class="label-area">{{ value }}円</div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'ExhibitPrice',
  props: {
    value: {
      type: Number
    },
    spanTitle: {
      type: Number
    },
    spanSetting: {
      type: Number
    }
  }
}
</script>

<style scoped>
div.input-title {
  text-align: end;
  vertical-align: middle;
  margin-top: 5px;
  margin-right: 10px;
}
div.label-area {
  text-align: center;
  font-size: x-large;
  font-weight: bold;
  color: #AA11AA
}
</style>
